import React from 'react';

import Link from 'app/common/components/Link';
import { getBaseAuthUrl } from 'app/developer-v3/utils';

type Props = {
  integrationId: number;
  version: string;
};

function NeedsAuthMessage({ integrationId, version }: Props) {
  return (
    <span>
      Finish{' '}
      <Link href={`${getBaseAuthUrl(integrationId, version)}/edit`}>
        configuring authentication
      </Link>{' '}
      so you can test your Trigger
    </span>
  );
}

export default NeedsAuthMessage;
